import React from "react";

import { Chip, Stack, Typography } from "@mui/material";

import type { GitOpsStatus } from "src/domains/application/hooks/useGitOpsStatus";

export interface PipelineControlsProps {
  gitopsStatus: GitOpsStatus | null;
}

export function PipelineControls({
  gitopsStatus,
}: PipelineControlsProps): React.ReactElement | null {
  if (!gitopsStatus) return null;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="caption" color="text.secondary">
        GitOps:
      </Typography>
      <Chip
        label={gitopsStatus.syncStatus}
        size="small"
        color={
          gitopsStatus.syncStatus === "Synced"
            ? "success"
            : gitopsStatus.syncStatus === "OutOfSync"
              ? "warning"
              : "default"
        }
        variant="outlined"
      />
      <Chip
        label={gitopsStatus.healthStatus}
        size="small"
        color={
          gitopsStatus.healthStatus === "Healthy"
            ? "success"
            : gitopsStatus.healthStatus === "Degraded"
              ? "error"
              : gitopsStatus.healthStatus === "Progressing"
                ? "info"
                : "default"
        }
        variant="outlined"
      />
      {gitopsStatus.revision && (
        <Typography variant="caption" color="text.disabled">
          {gitopsStatus.revision.slice(0, 7)}
        </Typography>
      )}
    </Stack>
  );
}
